import { StyleSheet } from 'react-native';
import { colors, fonts } from '@mmt/legacy-commons/Styles/globalStyles';

export const style = StyleSheet.create({
  thankyouHeader: {
    paddingHorizontal: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  thankyouBSSubTitle: {
    fontFamily: fonts.regular,
    fontSize: 14,
    lineHeight: 16,
    marginBottom: 8,
    color: colors.defaultTextColor,
    textAlign: 'center',
  },
  thankyouBSTitle: {
    fontFamily: fonts.black,
    fontSize: 18,
    color: colors.black,
    textAlign: 'center',
  },
  thankyouBSCode: {
    fontFamily: fonts.regular,
    fontSize: 14,
    lineHeight: 16,
    marginTop: 8,
    color: colors.black,
  },
  thankyouBSTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor:'#E6FFF9',
    borderRadius: 8,
    gap: 8,
    padding: 8,
    marginTop: 8,
    marginHorizontal: 16,
  },
  thankyouBSImage:{
    height:16,
    width:16,
  },  
  thankyouBSText: {
    fontSize:12,
    fontFamily: fonts.regular,
    color: colors.textGrey,

  },
  thankyouBSHighlightedTitle: {
    fontFamily: fonts.black,
    fontSize: 18,
    color: colors.primary,
    textAlign: 'center',
  },
  imageCard: {
    borderRadius: 12,
    overflow: 'hidden',
    marginRight: 10,
  },
  seperator: {
    width: 10,
  },
  imageCarouselContainer: {
    alignItems: 'center',
  },
  closeIconContainer: {
    bottom: 60,
    backgroundColor: colors.backgroundColor,
    width: 32,
    height: 32,
    borderRadius: 50,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
  },
  closeIcon: {
    width: 12,
    height: 12,
  },
  widgetWrapper: {
    paddingVertical: 20,
    marginBottom: 16,
    backgroundColor: '#FFFFFF',
  },
  widgetButtonText: {
    fontSize: 16,
    fontFamily: fonts.black,
    color: colors.white,
  },
  skipCta: {
    fontSize: 16,
    fontFamily: fonts.bold,
    color: colors.greyText1,
  },
  padVr16: {
    paddingVertical: 16
  },
  primaryButton: {
    backgroundColor: colors.azure,
    borderRadius: 8,
    paddingVertical: 12,
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 16,
    marginTop: 16,
  },
  textButton: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
  },
  buttonHorizontalPadding: {
    marginHorizontal: 16,
  },
  buttonContainer: {
    marginHorizontal: 16,
    marginTop: 16,
  },
  gradient: {
    borderRadius: 5,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 12,
  },
});
